module.exports = __webpack_public_path__ + "img/iot-cnc.c1b8f826.jpg";